export default function Hero() {
  return (
    <section id="hero" className="relative pt-[72px] bg-background-50 overflow-hidden">
      <div className="w-full max-w-[1440px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 md:gap-12 py-10 md:py-16 lg:py-20">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-4">
              <i className="ri-fire-line w-4 h-4 flex items-center justify-center"></i>
              <span>最新电影 · 新片上映 · 在线观看</span>
            </div>

            <h1 className="text-2xl md:text-4xl lg:text-5xl font-heading text-foreground-950 leading-tight mb-3">
              6080电影网 — 最新电影抢先看，高清不缓冲免费大片
            </h1>

            <p className="text-base md:text-lg text-primary-600 font-medium mb-5">
              秒开无广告，最新大片一次看个够
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0">
              6080电影网汇集全球最新上映影片，从好莱坞巨制到国产口碑佳作，每日更新10部以上新片。
              全平台高清流畅播放，无需注册、无需付费、全程无广告，打开即看，让每一次观影都纯粹而尽兴。
              这个暑期，无论是科幻迷、悬疑控还是喜剧爱好者，都能在这里找到属于你的那部电影。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-6">
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-accent-600">10+</div>
                <div className="text-xs text-foreground-500">每日更新（部）</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-accent-600">4K</div>
                <div className="text-xs text-foreground-500">超清画质</div>
              </div>
              <div className="w-px h-8 bg-background-300 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-lg md:text-xl font-bold text-accent-600">0</div>
                <div className="text-xs text-foreground-500">广告 · 费用</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a href="#cards" className="w-full sm:w-auto px-8 py-3 bg-primary-500 text-background-50 font-medium text-sm rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap text-center">
                <i className="ri-play-circle-line w-5 h-5 mr-2 inline-flex items-center justify-center align-middle"></i>
                立即观影
              </a>
              <a href="#updates" className="w-full sm:w-auto px-8 py-3 border border-background-300 text-foreground-700 font-medium text-sm rounded-md hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap text-center">
                <i className="ri-article-line w-5 h-5 mr-2 inline-flex items-center justify-center align-middle"></i>
                最新快讯
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative w-full aspect-[4/3] lg:aspect-[5/4] rounded-lg overflow-hidden">
              <img
                src="https://readdy.ai/api/search-image?query=warm%20golden%20cinematic%20abstract%20illustration%20with%20floating%20film%20reel%20silhouettes%20soft%20geometric%20shapes%20modern%20home%20theater%20atmosphere%20elegant%20minimalist%20composition%20amber%20and%20coral%20tones%20no%20text&width=1400&height=1050&seq=hero-main-01&orientation=squarish"
                alt="6080电影网 - 最新电影在线观看平台主视觉"
                title="6080电影网：最新电影抢先看"
                className="w-full h-full object-cover object-top"
                onError={(e) => { (e.target as HTMLElement).style.display = 'none'; }}
              />
              <div className="absolute inset-0 bg-gradient-to-br from-black/10 via-transparent to-black/5"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}